import {Component, Input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-radar-svg',
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './radar-svg.component.html',
  styleUrl: './radar-svg.component.css'
})
export class RadarSvgComponent {
  
  @Input() width: string = '50'
  @Input() height: string = '50'
  @Input() online: boolean = false
  protected onlineBackgroundColor = '#0076f7'
  protected offlineBackgroundColor = '#FF401F'
  
}
